import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Main Footer Content */}
        <div className="footer-main">
          <div className="footer-brand">
            <h2 className="footer-logo">CBC Center</h2>
            <p className="footer-tagline">
              Empowering students and educators with quality CBC resources.
            </p>
          </div>

          <div className="footer-links-container">
            <h3 className="link-group-title">Quick Links</h3>
            <div className="footer-links">
              <div className="link-column">
                <ul className="link-list">
                  <li><Link to="/about" className="footer-link">About</Link></li>
                  <li><Link to="/faq" className="footer-link">FAQ</Link></li>
                </ul>
              </div>
              <div className="link-column">
                <ul className="link-list">
                  <li><Link to="/privacy" className="footer-link">Privacy Policy</Link></li>
                  <li><Link to="/terms" className="footer-link">Terms of Service</Link></li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Newsletter */}
        <div className="footer-newsletter">
          <h3 className="newsletter-title">Stay Updated</h3>
          <p className="newsletter-description">
            Get the latest CBC curriculum updates and resources directly in your inbox
          </p>
          <form className="newsletter-form">
            <input
              type="email"
              placeholder="Enter your email"
              className="newsletter-input"
              aria-label="Email address for newsletter"
              required
            />
            <button type="submit" className="newsletter-btn">
              Subscribe
            </button>
          </form>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="copyright">
            © {currentYear} CBC Center. All rights reserved.
          </div>
        </div>
      </div>

      {/* Back to Top */}
      <button 
        className="back-to-top"
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        aria-label="Back to top"
      >
        ↑
      </button>
    </footer>
  );
};

export default Footer;